<!-- 各类型农机在册数(前十名) -->
<template>
  <div :id="id" :style="{ height: height, width: width }" />
</template>
<script>
import * as echarts from "echarts";
import resize from "@/components/chart/mixins/resize";
let chartVm = null;
function toThousandFilter(num) {
  return (+num || 0)
    .toString()
    .replace(/^-?\d+/g, (m) => m.replace(/(?=(?!\b)(\d{3})+$)/g, ","));
}
// const rhombus = require('@/assets/images/governmentAffairs/vehiclesupervisor/rhombus.png');;
export default {
  mixins: [resize],
  props: {
    id: {
      type: String,
      default: "rightFirstChart",
    },
    width: {
      type: String,
      default: "100%",
    },
    height: {
      type: String,
      default: "100%",
    },
    chartData: {
      type: Object,
      default: () => {
        return {
          names: [],
          nums: [],
        };
      },
    },
  },
  data() {
    return {
      chart: null,
      // 立体柱状图颜色
      colorArr: [
        ["rgba(125, 85, 6, ", "rgba(217, 152, 24, "],
        ["rgba(92, 62, 4, ", "rgba(117, 79, 4, "],
        ["rgba(255, 193, 69, "],
      ],
      options: {
        // tooltip: {
        //     trigger: 'axis',
        //     axisPointer: {
        //         type: 'shadow'
        //     }
        // },
        grid: [
          {
            top: "6%",
            bottom: "14%",
            left: "24%",
            width: "60%",
          },
        ],
        dataZoom: [
          {
            type: "slider",
            yAxisIndex: 0,
            startValue: 0,
            endValue: 4,
            zoomLock: true,
            show: false,
          },
        ],
        xAxis: {
          type: "value",
          axisTick: {
            show: false,
          },
          axisLabel: {
            formatter: (value, index) => (index % 2 === 0 ? value : ""), // 每隔一个显示
            color: "#BABBBD",
            fontSize: 12,
            margin: -1,
            // formatter: '{value}'
          },
          splitLine: false,
          axisLine: {
            show: false,
          },
          formatter: "{value}",
        },
        yAxis: {
          name: "(台)",
          nameTextStyle: {
            color: "#BABBBD",
            fontSize: 12,
            align: "right",
            verticalAlign: "top", // 底部对齐
            padding: [0, 40, 0, 0],
          },
          nameLocation: "start",
          nameGap: -2, // 调整名称与轴的距离
          type: "category",
          axisTick: {
            show: false,
          },
          axisLabel: {
            show: true,
            color: "#BABBBD",
            fontSize: 12,
            margin: 8,
            formatter: function (params) {
              const maxChars = 5; // 每行字符数
              let result = "";
              for (let i = 0; i < params.length; i += maxChars) {
                result += params.substring(i, i + maxChars) + "\n";
              }
              return result.trim();
            },
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: "rgba(88, 252, 146, 0.17)",
              width: 2,
            },
          },
        },
      },
    };
  },
  watch: {
    chartData: {
      deep: true,
      handler(val) {
        this.initChart();
      },
    },
  },
  mounted() {
    this.initChart();
    chartVm = this;
  },
  created() {},
  beforeDestroy() {
    if (!this.chart) {
      return;
    }
    this.chart.dispose();
    this.chart = null;
  },
  activated() {
    this.$nextTick(function () {
      setTimeout(() => {
        this.chart.resize();
      }, 500);
    });
  },
  methods: {
    initChart() {
      if (!this.chart) {
        this.chart = echarts.init(document.getElementById(this.id));
      }
      this.setChartData();
    },
    setChartData() {
      this.options.yAxis.data = this.chartData.names;
      let series = [];
      let that = this;
      // 右侧立体柱状图上
      series.push({
        type: "bar",
        barGap: 0,
        barWidth: "3",
        data: that.chartData.nums,
        label: {
          show: true,
          padding: [10, -8, 0, 2],
          position: "right",
          color: "#FFFFFF",
          formatter: function (params) {
            if (params.value > 0) {
              return toThousandFilter(params.value);
            } else {
              return "";
            }
          },
        },
        itemStyle: {
          normal: {
            color: function (params) {
              return new echarts.graphic.LinearGradient(
                1,
                0,
                0,
                0,
                //渐变色在下面修改，这里是透明度
                [
                  {
                    offset: 0,
                    color: that.colorArr[1][1] + "1)",
                  },
                  {
                    offset: 1,
                    color: that.colorArr[1][0] + "1)",
                  },
                ]
              );
            },
          },
        },
      });
      // 右侧立体柱状图下
      series.push({
        type: "bar",
        barGap: 0,
        barWidth: "10",
        data: that.chartData.nums,
        itemStyle: {
          normal: {
            color: function (params) {
              return new echarts.graphic.LinearGradient(
                1,
                0,
                0,
                0,
                //渐变色在下面修改，这里是透明度
                [
                  {
                    offset: 0,
                    color: that.colorArr[0][1] + "1)",
                  },
                  {
                    offset: 1,
                    color: that.colorArr[0][0] + "1)",
                  },
                ]
              );
            },
          },
        },
      });
      // 右边最下面菱形
      // series.push(
      //   {
      //     data: that.chartData.nums,
      //     type: 'pictorialBar',
      //     // symbol: 'diamond',
      //     symbol: function(value, params, dataIndex) {
      //       return  `image://${rhombus}`;
      //     },
      //     // symbolRotate: 2,
      //     symbolSize: [7, 12.4],
      //     symbolPosition: 'end',
      //     symbolOffset: [5, 1],
      //     itemStyle: {
      //       normal: {
      //         color: function(params) {
      //           return that.colorArr[2][0] + '1)';
      //         }
      //       },
      //     }
      //   }
      // );
      this.options.series = series;
      this.chart.setOption(this.options);

      // let currentStart = 0;
      // if (that.chartData.nums.length > 5) {
      //   currentStart = (currentStart + 1) % that.chartData.nums.length;
      //   const newEnd = currentStart + 4 >= that.chartData.nums.length
      //     ? that.chartData.nums.length - 1
      //     : currentStart + 4;

      //     that.options.dataZoom = [{
      //       startValue: currentStart,
      //       endValue: newEnd
      //     }]
      //     that.chart.setOption(that.options);
      // }else {
      //   this.chart.setOption(this.options);
      // }
    },
  },
};
</script>
